<div class="jobseeker-education">
  <div *ngIf="isEditModeOn"></div>
  <div *ngIf="!isEditModeOn">
    <table>
      <tr>
        <td style="text-align: left; min-width: 84px">
          <button
            class="fa fa-times-circle btn btn-link"
            (click)="onDeleteEducationClick()"
            [disabled]="isEditModeOn"
          ></button>
          <button
            class="fa fa-pencil btn btn-link"
            (click)="onEditEducationClick()"
            *ngIf="item.jobseekerEducationId > 0"
            [disabled]="isEditModeOn"
          ></button>
        </td>
        <td width="80%" colspan="1">
          <span
            >{{ item.dateFromYear }}
            {{ monthListShortMap[item.dateFromMonth] }} - {{ item.dateToYear }}
            {{ monthListShortMap[item.dateToMonth] }}</span
          >
          <span>
            &nbsp; &nbsp; | &nbsp; &nbsp; {{ item.educationLevel.name }}</span
          >
          <span *ngIf="item.specialization != null">
            &nbsp; &nbsp; | &nbsp; &nbsp; {{ item.specialization }}</span
          >
          <span *ngIf="item.educationalProgramName != null">
            &nbsp; &nbsp; | &nbsp; &nbsp;
            {{ item.educationalProgramName }}</span
          >
          <span class="institution">
            &nbsp; &nbsp; | &nbsp; &nbsp; {{ item.institution }}
          </span>
        </td>
        <td style="text-align: right; width: 100%">
          <form
            id="{{ 'edatchmt_' + item.jobseekerEducationId }}"
            action="{{ getDownloadUrl() }}"
            method="post"
            target="_blank"
          >
            <span *ngIf="item.attachment != null">
              <a
                target="_blank"
                href="javascript:void(0)"
                (click)="
                  onDownloadEducationAttachmentClick(
                    'edatchmt_' + item.jobseekerEducationId
                  )
                "
                ><i class="fa fa-paperclip icon"></i>&nbsp;{{
                  'label.Attachment' | translate
                }}</a
              >
            </span>
            <!--<input type="hidden" name="jobseekerEducationId" value="{{item.jobseekerEducationId}}" />
            <input type="hidden" name="isPending" value="{{pendingJobseekerEducationsMap[item.jobseekerEducationId] != null}}" />
            <input type="hidden" name="isNew" value="{{item.jobseekerEducationId<0}}" />-->
          </form>
        </td>
      </tr>
      <tr>
        <td colspan="4">&nbsp;</td>
      </tr>
      <tr>
        <td></td>
        <td
          [innerHtml]="
            item?.description != null ? item.description + '&nbsp;' : '&nbsp;'
          "
        ></td>
        <td></td>
      </tr>
    </table>
  </div>
  <hr-education-editor
    *ngIf="isEditModeOn"
    [education]="education"
    (onCancelEdit)="onCancelEditEducation()"
    (onUpdate)="onEducationEdited($event)"
  ></hr-education-editor>
  <iframe
    name="hiddenFrame"
    style="position: absolute; top: -1px; left: -1px; width: 1px; height: 1px"
  ></iframe>
</div>
